import { AbstractControl, ValidationErrors } from '@angular/forms';

export function requiredTrimmedValidator(control: AbstractControl): ValidationErrors | null {
    console.log(control);
    if (!control.value.trim()) {
        return { required: true };
    }
    return null;
}
